<template>
<!--  <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>-->
  <div class="big-loader-wrapper">
    <div class="big-loader">
      <svg width="107" height="106" class="svg" viewBox="0 0 67 66" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M53.5776 17.7469C63.6734 30.683 62.3929 42.8063 54.1539 47.5631C45.9148 52.3199 15.3668 51.669 10.61 43.43C5.85318 35.191 15.0551 17.7203 23.2941 12.9635C31.5331 8.20669 48.8208 9.50791 53.5776 17.7469Z" fill="#3E008C"/>
        <path d="M17.701 26.2143C17.2237 21.6572 19.3186 18.9752 21.9715 19.0671C24.6243 19.1591 31.7576 23.8313 31.6656 26.4863C31.5736 29.1412 26.8137 31.9182 24.1608 31.8263C21.5079 31.7343 17.609 28.8693 17.701 26.2143Z" fill="white"/>
        <path d="M31.0843 43.8501C29.3926 42.0811 29.4015 40.2627 30.5532 39.4335C31.7049 38.6044 36.2485 38.2443 37.0776 39.396C37.9067 40.5476 36.8021 43.2781 35.6504 44.1073C34.4987 44.9364 31.9135 45.0017 31.0843 43.8501Z" fill="white"/>
        <path d="M39.5303 31.2747C35.703 28.7555 34.9562 25.4352 36.7088 23.4415C38.4613 21.4478 46.5964 18.8917 48.5917 20.6456C50.5869 22.3995 49.718 27.8412 47.9654 29.835C46.2129 31.8287 41.5256 33.0286 39.5303 31.2747Z" fill="white"/>
      </svg>
      <svg width="107" height="106" class="svg" ref="svg" viewBox="0 0 67 65" fill="none" xmlns="http://www.w3.org/2000/svg" id="first">
        <path d="M52.989 16.9129C63.0848 29.849 61.8043 41.9724 53.5652 46.7292C45.3262 51.486 14.7782 50.835 10.0214 42.596C5.26456 34.357 14.4665 16.8863 22.7055 12.1295C30.9445 7.3727 48.2322 8.67392 52.989 16.9129Z" fill="black"/>
        <path d="M29.5844 20.3808C32.4031 23.9933 32.0469 27.3778 29.748 28.705C27.4492 30.0323 18.924 29.8477 17.5957 27.547C16.2674 25.2464 18.8338 20.3698 21.1326 19.0425C23.4315 17.7153 28.2562 18.0802 29.5844 20.3808Z" fill="white"/>
        <path d="M36.1535 38.1487C37.6594 40.0783 37.4684 41.8866 36.2394 42.5962C35.0104 43.3058 30.4536 43.2087 29.7441 41.9798C29.0346 40.7508 30.4072 38.1447 31.6362 37.4352C32.8652 36.7256 35.444 36.9197 36.1535 38.1487Z" fill="white"/>
        <path d="M45.6678 18.2393C49.8496 20.1122 51.1191 23.2697 49.7089 25.5187C48.2988 27.7676 40.6788 31.5951 38.4281 30.1839C36.1775 28.7726 36.1626 23.2619 37.5727 21.013C38.9829 18.764 43.4171 16.8281 45.6678 18.2393Z" fill="white"/>
      </svg>
      <svg width="107" height="106" class="svg" viewBox="0 0 67 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M53.3462 17.3299C63.4419 30.266 62.1614 42.3893 53.9224 47.1461C45.6834 51.9029 15.1353 51.252 10.3785 43.013C5.62173 34.774 14.8236 17.3033 23.0627 12.5465C31.3017 7.7897 48.5894 9.09092 53.3462 17.3299Z" fill="#A81B1B"/>
        <path d="M29.9416 20.7976C32.7603 24.41 32.4041 27.7945 30.1052 29.1218C27.8064 30.449 19.2811 30.2644 17.9529 27.9638C16.6246 25.6632 19.191 20.7865 21.4898 19.4593C23.7887 18.132 28.6133 18.4969 29.9416 20.7976Z" fill="white"/>
        <path d="M30.8528 43.4328C29.1611 41.6638 29.1699 39.8454 30.3216 39.0163C31.4733 38.1871 36.0169 37.827 36.846 38.9787C37.6751 40.1304 36.5705 42.8609 35.4188 43.69C34.2671 44.5192 31.6819 44.5845 30.8528 43.4328Z" fill="white"/>
        <path d="M50.04 23.8323C50.834 28.345 48.9313 31.1666 46.2785 31.2599C43.6256 31.3533 36.1838 27.19 36.0904 24.5351C35.997 21.8802 40.5515 18.778 43.2044 18.6846C45.8572 18.5912 49.9465 21.1774 50.04 23.8323Z" fill="white"/>
      </svg>

    </div>
  </div>

</template>

<script>
export default {
  methods: {

  },
  mounted() {
    let length = 0
    const svg = document.querySelectorAll('.svg')
    setInterval(() => {
      for (let icon of svg){
        icon.style.display = 'none'
      }
      svg[length].style.display = 'block'
      length++
      if (length === 3){
        length = 0
      }
    },150)
  }
}
</script>

<style lang="scss">


.svg{
  position: absolute;
}
.big-loader-wrapper{
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255,255,255,1);
  z-index: 1000000;
  transition: all .4s;
  .done{
    transform: translateY(100%);
  }
  .active{

  }
}
.big-loader{
  height: 70px;
  width: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin: 0 auto;

}

</style>